export default "__VITE_ASSET__BTFx31z___"